import { http } from '@/http'

export default {
  downloadTemplate() {
    return http.get('/contracts/bulk-upload/template', { responseType: 'blob' })
  },
  validate(file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post('/contracts/bulk-upload/validate', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  confirm(batchId) {
    return http.post(`/contracts/bulk-upload/confirm/${batchId}`)
  },
  downloadErrors(batchId) {
    return http.get(`/contracts/bulk-upload/errors/${batchId}`, { responseType: 'blob' })
  },
}
